import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { EventStatus } from '@enum/event/EventStatus';

export class PatientEventsHistoryPageCriteriaDTO extends PageCriteriaDTO {
  public eventStatus: EventStatus;
}